import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input";
import { validationMixin } from "vuelidate";
import { not, sameAs, requiredIf } from "vuelidate/lib/validators";
import { validPassword, validOldPassword } from "@Shared/@Utils/validation-rules";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ChangePassword",
  components: {
    MaterialInput
  },
  mixins: [validationMixin],
  validations: {
    currentPassword: {
      validOldPassword,
      required: requiredIf(function () {
        return !!this.newPassword || !!this.confirmPassword;
      })
    },
    newPassword: {
      validPassword,
      notSameAsCurrentPassword: not(sameAs("currentPassword")),
      required: requiredIf(function () {
        return !!this.currentPassword || !!this.confirmPassword;
      })
    },
    confirmPassword: {
      validPassword,
      confirmPassword: sameAs("newPassword"),
      required: requiredIf(function () {
        return !!this.currentPassword || !!this.newPassword;
      })
    }
  },
  data() {
    return {
      currentPassword: "",
      newPassword: "",
      confirmPassword: ""
    };
  },
  computed: {
    isFirefox() {
      var _context;
      return _includesInstanceProperty(_context = window.navigator.userAgent).call(_context, "Firefox");
    },
    isFormValid() {
      return !this.$v.$invalid;
    }
  },
  watch: {
    isFormValid: {
      handler(valid) {
        this.$emit("allow-save", valid);
      }
    }
  },
  methods: {
    handleInitialSubmit() {
      this.$emit("initial-submit");
    },
    handleSubmit() {
      if (this.isFormValid) {
        this.$emit("submit", {
          currentPassword: this.currentPassword,
          newPassword: this.newPassword
        });
      }
    },
    clearPasswords() {
      this.currentPassword = "";
      this.newPassword = "";
      this.confirmPassword = "";
    },
    handleFormChange() {
      this.$emit("form-change", "changePassword");
      this.$emit("allow-save", this.isFormValid);
    }
  }
});